import CodelocksPeriodSelectorJson from './interfaces/CodelocksPeriodSelectorJson'
import { DateTime } from 'luxon'
import RelativeDurationPeriod from '../../period/RelativeDurationPeriod'

export default class CodelocksPeriodSelector {
  startDate: DateTime
  endDate: DateTime
  minDuration: RelativeDurationPeriod
  maxDuration: RelativeDurationPeriod | null

  constructor(
    startDate: DateTime,
    endDate: DateTime,
    minDuration: RelativeDurationPeriod,
    maxDuration: RelativeDurationPeriod | null,
  ) {
    this.startDate = startDate
    this.endDate = endDate
    this.minDuration = minDuration
    this.maxDuration = maxDuration
  }

  isExpired(now: DateTime) {
    return now > this.endDate
  }

  static fromJson(data: CodelocksPeriodSelectorJson) {
    return new this(
      DateTime.fromISO(data.startDate.date, {
        zone: data.startDate.timezone,
      }),
      DateTime.fromISO(data.endDate.date, {
        zone: data.endDate.timezone,
      }),
      RelativeDurationPeriod.fromJson(data.minDuration),
      data.maxDuration
        ? RelativeDurationPeriod.fromJson(data.maxDuration)
        : null,
    )
  }
}
